import React from "react";

export const SERIES = [
  {
    id: "finance",
    name: "Finance for Little Hands",
    number: "01",
    target: "#books-finance",
    status: "available",
    note: "Paperback + Kindle eBooks",
  },
  {
    id: "ai",
    name: "AI for Little Hands",
    number: "02",
    target: "#books-ai",
    status: "available",
    note: "Paperback editions",
  },
];

export const BOOKS = [
  {
    id: "the-money-mystery",
    number: "01",
    title: "The Money Mystery",
    subtitle: "Maya's Guide to Discovering Money",
    year: "2026",
    tone: "yellow",
    color: "#FBBF24",
    cover:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/d4hpn4w1_cover_page_image.jpg",
    blurb:
      "Follow Maya as she uncovers what money really is — from clinking coins to crumpled bills — and why grown-ups treat it like treasure.",
    themes: ["What money is", "History of coins", "Value & worth"],
    pages: 28,
    ageRange: "4–10",
    formats: "Paperback + Kindle eBook",
    status: "available",
  },
  {
    id: "the-bank-adventure",
    number: "02",
    title: "The Bank Adventure",
    subtitle: "Maya's Guide to Accounts, Debit & Credit",
    year: "2026",
    tone: "pink",
    color: "#F472B6",
    cover:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/47ld53yd_cover_page_image.jpg",
    blurb:
      "Maya opens her very first bank account, meets debit cards and credit cards, and discovers the gentle rhythm of money going in and money going out.",
    themes: ["Bank accounts", "Debit vs credit", "Money in, money out"],
    pages: 26,
    ageRange: "4–10",
    formats: "Paperback + Kindle eBook",
    status: "available",
  },
  {
    id: "do-i-really-need-it",
    number: "03",
    title: "Do I Really Need It?",
    subtitle: "Maya's Guide to Spending Wisely",
    year: "2026",
    tone: "green",
    color: "#34D399",
    cover:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/rkp3cnyr_Thumbnail_cover_image.png",
    blurb:
      "An apple, a rocket, and one shiny coin. Maya learns the small, brave pause between want and need.",
    themes: ["Needs vs wants", "Delayed gratification", "Choices"],
    pages: 26,
    ageRange: "5–9",
    formats: "Paperback + Kindle eBook",
    status: "available",
  },
];

export const UPCOMING_BOOKS = [
  {
    id: "04",
    number: "04",
    title: "The Growing Coin",
    subtitle: "Maya's Guide to Investments & Interest",
    hint: "How money quietly grows while you sleep — investments, interest, and the slow magic of compounding, told through Maya's very first tiny investment.",
  },
  {
    id: "05",
    number: "05",
    title: "What I Own, What I Owe",
    subtitle: "Maya's Guide to Assets, Liabilities & Loans",
    hint: "Some things add to your bucket. Some things take from it. Maya learns what a house, a car, a loan and a mortgage really mean — one careful page at a time.",
  },
];

export const COUNTRIES = [
  { code: "US", label: "United States", flag: "🇺🇸", store: "Amazon.com" },
  { code: "UK", label: "United Kingdom", flag: "🇬🇧", store: "Amazon.co.uk" },
  { code: "CA", label: "Canada", flag: "🇨🇦", store: "Amazon.ca" },
  { code: "JP", label: "Japan", flag: "🇯🇵", store: "Amazon.co.jp" },
  { code: "AU", label: "Australia", flag: "🇦🇺", store: "Amazon.com.au" },
  { code: "IN", label: "India", flag: "🇮🇳", store: "Amazon.in" },
  { code: "BR", label: "Brazil", flag: "🇧🇷", store: "Amazon.com.br" },
  { code: "IT", label: "Italy", flag: "🇮🇹", store: "Amazon.it" },
  { code: "FR", label: "France", flag: "🇫🇷", store: "Amazon.fr" },
  { code: "DE", label: "Germany", flag: "🇩🇪", store: "Amazon.de" },
  { code: "ES", label: "Spain", flag: "🇪🇸", store: "Amazon.es" },
  { code: "DK", label: "Denmark", flag: "🇩🇰", store: "Amazon.de" },
  { code: "NL", label: "Netherlands", flag: "🇳🇱", store: "Amazon.nl" },
  { code: "MX", label: "Mexico", flag: "🇲🇽", store: "Amazon.com.mx" },
  { code: "SE", label: "Sweden", flag: "🇸🇪", store: "Amazon.se" },
  { code: "BE", label: "Belgium", flag: "🇧🇪", store: "Amazon.com.be" },
];

export const BUY_LINKS = {
  "the-money-mystery": {
    US: "https://www.amazon.com/dp/B0H71NJPRR",
    UK: "https://www.amazon.co.uk/dp/B0H71NJPRR",
    CA: "https://www.amazon.ca/dp/B0H71NJPRR",
    JP: "https://www.amazon.co.jp/dp/B0H71NJPRR",
    AU: "https://www.amazon.com.au/dp/B0H71NJPRR",
    IN: "https://www.amazon.in/dp/B0HHNMGWLT",
    BR: "https://www.amazon.com.br/dp/B0HHNMGWLT",
    IT: "https://www.amazon.it/dp/B0H71NJPRR",
    FR: "https://www.amazon.fr/dp/B0H71NJPRR",
    DE: "https://www.amazon.de/dp/B0H71NJPRR",
    ES: "https://www.amazon.es/dp/B0H71NJPRR",
    DK: "https://www.amazon.de/dp/B0H71NJPRR",
    NL: "https://www.amazon.nl/dp/B0H71NJPRR",
    MX: "https://www.amazon.com.mx/dp/B0HHNMGWLT",
    SE: "https://www.amazon.se/dp/B0H71NJPRR",
    BE: "https://www.amazon.com.be/dp/B0H71NJPRR",
  },
  "the-bank-adventure": {
    US: "https://www.amazon.com/dp/B0HJMGKQQQ",
    UK: "https://www.amazon.co.uk/dp/B0HJMGKQQQ",
    CA: "https://www.amazon.ca/dp/B0HJMGKQQQ",
    JP: "https://www.amazon.co.jp/dp/B0HJMGKQQQ",
    AU: "https://www.amazon.com.au/dp/B0HJMGKQQQ",
    IN: "https://www.amazon.in/dp/B0HJQFMV7V",
    BR: "https://www.amazon.com.br/dp/B0HJQFMV7V",
    IT: "https://www.amazon.it/dp/B0HJMGKQQQ",
    FR: "https://www.amazon.fr/dp/B0HJMGKQQQ",
    DE: "https://www.amazon.de/dp/B0HJMGKQQQ",
    ES: "https://www.amazon.es/dp/B0HJMGKQQQ",
    DK: "https://www.amazon.de/dp/B0HJMGKQQQ",
    NL: "https://www.amazon.nl/dp/B0HJMGKQQQ",
    MX: "https://www.amazon.com.mx/dp/B0HJQFMV7V",
    SE: "https://www.amazon.se/dp/B0HJMGKQQQ",
    BE: "https://www.amazon.com.be/dp/B0HJMGKQQQ",
  },
  "do-i-really-need-it": {
    US: "https://www.amazon.com/dp/B0H7465NJ3",
    UK: "https://www.amazon.co.uk/dp/B0H7465NJ3",
    CA: "https://www.amazon.ca/dp/B0H7465NJ3",
    JP: "https://www.amazon.co.jp/dp/B0H7465NJ3",
    AU: "https://www.amazon.com.au/dp/B0H7465NJ3",
    IN: "https://www.amazon.in/dp/B0HKX4RN7F",
    BR: "https://www.amazon.com.br/dp/B0HKX4RN7F",
    IT: "https://www.amazon.it/dp/B0H7465NJ3",
    FR: "https://www.amazon.fr/dp/B0H7465NJ3",
    DE: "https://www.amazon.de/dp/B0H7465NJ3",
    ES: "https://www.amazon.es/dp/B0H7465NJ3",
    DK: "https://www.amazon.de/dp/B0H7465NJ3",
    NL: "https://www.amazon.nl/dp/B0H7465NJ3",
    MX: "https://www.amazon.com.mx/dp/B0HKX4RN7F",
    SE: "https://www.amazon.se/dp/B0H7465NJ3",
    BE: "https://www.amazon.com.be/dp/B0H7465NJ3",
  },
  "the-big-discovery": {
    US: "https://www.amazon.com/dp/B0HCLF527M",
    UK: "https://www.amazon.co.uk/dp/B0HCLF527M",
    CA: "https://www.amazon.ca/dp/B0HCLF527M",
    JP: "https://www.amazon.co.jp/dp/B0HCLF527M",
    AU: "https://www.amazon.com.au/dp/B0HCLF527M",
    IN: "https://www.amazon.in/dp/B0HCLF527M",
    BR: "https://www.amazon.com.br/dp/B0HCLF527M",
    IT: "https://www.amazon.it/dp/B0HCLF527M",
    FR: "https://www.amazon.fr/dp/B0HCLF527M",
    DE: "https://www.amazon.de/dp/B0HCLF527M",
    ES: "https://www.amazon.es/dp/B0HCLF527M",
    DK: "https://www.amazon.de/dp/B0HCLF527M",
    NL: "https://www.amazon.nl/dp/B0HCLF527M",
    MX: "https://www.amazon.com.mx/dp/B0HCLF527M",
    SE: "https://www.amazon.se/dp/B0HCLF527M",
    BE: "https://www.amazon.com.be/dp/B0HCLF527M",
  },
  "meet-my-new-helper": {
    US: "https://www.amazon.com/dp/B0HCNGWMP4",
    UK: "https://www.amazon.co.uk/dp/B0HCNGWMP4",
    CA: "https://www.amazon.ca/dp/B0HCNGWMP4",
    JP: "https://www.amazon.co.jp/dp/B0HCNGWMP4",
    AU: "https://www.amazon.com.au/dp/B0HCNGWMP4",
    IN: "https://www.amazon.in/dp/B0HCNGWMP4",
    BR: "https://www.amazon.com.br/dp/B0HCNGWMP4",
    IT: "https://www.amazon.it/dp/B0HCNGWMP4",
    FR: "https://www.amazon.fr/dp/B0HCNGWMP4",
    DE: "https://www.amazon.de/dp/B0HCNGWMP4",
    ES: "https://www.amazon.es/dp/B0HCNGWMP4",
    DK: "https://www.amazon.de/dp/B0HCNGWMP4",
    NL: "https://www.amazon.nl/dp/B0HCNGWMP4",
    MX: "https://www.amazon.com.mx/dp/B0HCNGWMP4",
    SE: "https://www.amazon.se/dp/B0HCNGWMP4",
    BE: "https://www.amazon.com.be/dp/B0HCNGWMP4",
  },
  "making-smart-choices": {
    US: "https://www.amazon.com/dp/B0HDC1FTXG",
    UK: "https://www.amazon.co.uk/dp/B0HDC1FTXG",
    CA: "https://www.amazon.ca/dp/B0HDC1FTXG",
    JP: "https://www.amazon.co.jp/dp/B0HDC1FTXG",
    AU: "https://www.amazon.com.au/dp/B0HDC1FTXG",
    IN: "https://www.amazon.in/dp/B0HDC1FTXG",
    BR: "https://www.amazon.com.br/dp/B0HDC1FTXG",
    IT: "https://www.amazon.it/dp/B0HDC1FTXG",
    FR: "https://www.amazon.fr/dp/B0HDC1FTXG",
    DE: "https://www.amazon.de/dp/B0HDC1FTXG",
    ES: "https://www.amazon.es/dp/B0HDC1FTXG",
    DK: "https://www.amazon.de/dp/B0HDC1FTXG",
    NL: "https://www.amazon.nl/dp/B0HDC1FTXG",
    MX: "https://www.amazon.com.mx/dp/B0HDC1FTXG",
    SE: "https://www.amazon.se/dp/B0HDC1FTXG",
    BE: "https://www.amazon.com.be/dp/B0HDC1FTXG",
  },
};

export const AI_BOOKS = [
  {
    id: "the-big-discovery",
    number: "01",
    title: "The Big Discovery",
    subtitle: "Maya's Guide to Computers and AI",
    year: "2026",
    tone: "teal",
    color: "#5EEAD4",
    cover:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/vhhz7fva_cover_page.png",
    blurb:
      "Maya meets a curious new friend that thinks in ones and zeros — and discovers what a computer, a brain, and an AI actually are.",
    themes: ["What is a computer", "What is AI", "Curiosity"],
    pages: 26,
    ageRange: "5+",
    formats: "Paperback",
    status: "available",
  },
  {
    id: "meet-my-new-helper",
    number: "02",
    title: "Meet My New Helper",
    subtitle: "Maya's Guide to How AI Helps Us",
    year: "2026",
    tone: "beige",
    color: "#FCD34D",
    cover:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/a719x64t_cover_page.png",
    blurb:
      "From homework hints to helpful reminders — how AI quietly helps in kitchens, schools, cars, and hospitals every single day.",
    themes: ["Everyday AI", "Helpers", "Real-world uses"],
    pages: 26,
    ageRange: "5+",
    formats: "Paperback",
    status: "available",
  },
  {
    id: "making-smart-choices",
    number: "03",
    title: "Making Smart Choices",
    subtitle: "Maya's Guide to Using AI Safely",
    year: "2026",
    tone: "pink",
    color: "#F9A8D4",
    cover:
      "https://customer-assets-jt897jd0.emergentagent.net/job_books-young-readers/artifacts/65hqrwxj_cover_page.png",
    blurb:
      "AI is powerful, but not always right. Maya learns to ask, check, and choose — the small habits that keep her thinking her own thoughts.",
    themes: ["AI safety", "Critical thinking", "Good habits"],
    pages: 28,
    ageRange: "5+",
    formats: "Paperback",
    status: "available",
  },
];

export const AI_SERIES = {
  seriesName: "AI for Little Hands",
  seriesNumber: "02",
  status: "available",
  tagline:
    "The next chapter — helping young minds grow up with the smartest tools of their generation, gently and thoughtfully.",
};


export const MANIFESTO = [
  {
    n: "01",
    title: "Small hands, big ideas.",
    body: "We believe the earliest years are when the biggest questions get asked. Books for Little Hands turns them into early financial literacy — quietly, warmly, and with room to wonder.",
  },
  {
    n: "02",
    title: "Money, made gentle.",
    body: "Finance is not a scary word. In our stories, coins are curious, budgets are buckets, and needs and wants take turns at the table.",
  },
  {
    n: "03",
    title: "One brave girl. Many little readers.",
    body: "Maya is the child every child recognises: unsure, honest, hopeful. She learns out loud so your child can learn along.",
  },
  {
    n: "04",
    title: "Story meets activity.",
    body: "Every book pairs Maya's story with simple, playful activities — sorting, spotting, tallying, deciding — so children don't just read about money, they practise it.",
  },
  {
    n: "05",
    title: "AI-crafted, human-shaped.",
    body: "Every page is thoughtfully created with the help of AI — illustration, storyboarding, and pacing — then carefully edited by the authors so the warmth, values, and voice stay unmistakably human.",
  },
];
